export default __webpack_public_path__ + "static/media/whitepaper.9ffafa40.pdf";